import ContentfulUniqueSellingPoint from '../reference-blocks/contentful-unique-selling-point'

import generateRTFComponent from '.'

const CRMHeaderRTF = generateRTFComponent({
  ContentfulUniqueSellingPoint,
})

export default CRMHeaderRTF
